module.exports = __webpack_public_path__ + "img/moneygun.9ed5d667.png";